enum ActionTypes {
  LOAD_BACK_OFFICE_USER_REQUEST = 'LOAD_BACK_OFFICE_USER_REQUEST',
  LOAD_BACK_OFFICE_USER_SUCCESS = 'LOAD_BACK_OFFICE_USER_SUCCESS',
  LOAD_BACK_OFFICE_USER_FAILURE = 'LOAD_BACK_OFFICE_USER_FAILURE',

  SET_BACK_OFFICE_USER = 'SET_BACK_OFFICE_USER'
}

export default ActionTypes;
